/**
 * Central place for support/administration contact details so they are never hardcoded
 * inline in feature components (FR55/h12-2 anti-pattern guidance). Interpolate these into
 * i18n strings via t(key, { email: ADMINISTRATION_EMAIL }).
 */
export const ADMINISTRATION_EMAIL = 'administratie@xxtract.com';
